// test542
(542 && 0);
